module.exports = __webpack_public_path__ + "4fa589cb26e75d98863a2e1b6da27a0a.jpg";